import { render } from "./ModalSk.vue?vue&type=template&id=18323147&scoped=true"
import script from "./ModalSk.vue?vue&type=script&lang=js"
export * from "./ModalSk.vue?vue&type=script&lang=js"

import "./ModalSk.vue?vue&type=style&index=0&id=18323147&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18323147"]])

export default __exports__